<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["UstDonemId", "DonemId","Sorgulama","BirimId"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            DonemAdi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
        BirimId() {
            this.Get();
        },
    },
    methods: {
        Get() {

            this.ActionsFilterGet({ Service: "StrRaporlama/GetBirimHedefGirisOraniTablosu", Page: this.Page, Filter: "&Donemid=" + this.DonemId + "&Ustdonemid=" + this.UstDonemId + "&Birimid=" + (this.BirimId == null ? "" : this.BirimId) }).then((res) => {
                this.TableData = res.Data;


            });
        },
        ExcelExport(table, name) {
            if (!table.nodeType) table = this.$refs.veriGiris;
            var html = table.innerHTML
            var ctx = { worksheet: name || 'Worksheet', table: html }
            var a = document.createElement('a');
            a.href = this.uri + this.base64(this.format(this.template, ctx));
            a.download = name + '.xls';
            a.click();
        },
    },

    computed: {},
    created() {
        this.Get();
    },
};
</script>
<template>
    <Loader>
        <div>
            <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'BirimHedefGirisOraniTablosu',
                        'BirimHedefGirisOraniTablosu',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div>
            <div ref="veriGiris" class="table-responsive">
                <div class="table-responsive">
                    <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                        <tr>
                            <td colspan="5" class="h5"
                                style="text-align: center; font-family: Arial; display: block;">
                                Birim Hedef Giriş Oranı Tablosu <br>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive">
                                        <table class="table-bordered">
                                            <tbody>
                                                <tr style="background-color: #2A3042; border-color:white; border-style: solid; color:white; text-align: center;">
                                                    <th class="col-md-2">Birimler</th>
                                                    <th class="col-md-2">Tanımlı Gösterge Sayısı</th>
                                                    <th class="col-md-2">Tanımlı Hedef Sayısı</th>
                                                    <th class="col-md-1">Girilen Hedef Sayısı</th>
                                                    <th class="col-md-1">Hedef Girme Oranı(%)</th>
                                                </tr>
                                            </tbody>
                                            <tr v-for="(Data, index) in TableData" :key="index"  style="text-align: center;">
                                                <td>{{ Data.Birimadi }}</td>
                                                <td>{{ Data.Tanimligosterge }}</td>
                                                <td>{{ Data.Tanimlihedef }}</td>
                                                <td>{{ Data.Girilenhedef }}</td>
                                                <td :style="'background:' + Data.Renk"><span style="color: white;">{{ Data.Oran }}</span></td>
                                            </tr>
   
                                        </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
</Loader>
</template>
<style>
td {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
